// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import { session } from 'wix-storage';
import { local } from 'wix-storage';

import wixLocation from 'wix-location';
import { encrypt, decrypt } from 'public/utils.js';
import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...
	if (local.getItem("auth-user")) {
		if(wixWindow.multilingual.currentLanguage === "fr"){
			$w("#bttnPlay").label = "Vidéos";
			
		}else{
			$w("#bttnPlay").label = "Videos";
		}
		
	} else {
		if(wixWindow.multilingual.currentLanguage === "fr"){
			$w("#bttnPlay").label = "Démarrer";
		}else{
			$w("#bttnPlay").label = "Start here";
		}
		
	}


	$w("#htmlSignin").onMessage( (event) => {
		
  		let receivedData = event.data;
		console.log('receivedData: '+ receivedData);

		let data = JSON.parse(receivedData);
		
		if(data.type==="USER-SIGNIN"){

			console.log('data type: '+ data.type);
	
			let user = data["user"];
			let video = data["lastVideo"];
			let presc = data["prescription"];
			let last_device = data["last_device"];

			if(user){
				console.log('displayName: '+ user.displayName);

				session.setItem("displayName", user.displayName);
				session.setItem("email", user.email);
				session.setItem("vidClip", video.clip);
				session.setItem("vidDesc", video.desc);
				session.setItem("vidUrl", video.url);
				session.setItem("vidType", video.type);
				//prescription
				session.setItem("fitbit", presc.fitbit);
				//device
				session.setItem("device", last_device);

				navigateToPersonalPage(presc.fitbit);
			}
		}
		
	} );

});

export function bttnPlay_click(event) {
	//Add your code for this event here: 
	if ($w('#bttnPlay').label === "Play" || $w('#bttnPlay').label === "Jouez") {
		siginUserIn();
	} else {
		wixLocation.to("/prescription-page");
	}
}

function siginUserIn() {

	let email = local.getItem("auth-user");
	let pwd = decrypt(local.getItem("auth-pwd"));

	console.log("WIX-HOME: message sent ");

	let credentials = {
		email: email,
		password: pwd
	}

	$w("#htmlSignin").postMessage(JSON.stringify(credentials));
	console.log("WIX-HOME: message sent");

}

function navigateToPersonalPage(fitbit) {
	//check for fitbit
	if (parseInt(fitbit, 10) === 1) {
		console.log(":to personal page with fitbit")
		wixLocation.to("/your-personal-page");

	} else {
		console.log(":to personal page withOUT fitbit")
		wixLocation.to("/your-personal-page-without-fitbit");
	}
}